import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/procurement/catalogs`;

export const procurementCatalogsAPI = {
  async getAll(catalogKey) {
    const query = catalogKey ? `?catalog_key=${encodeURIComponent(catalogKey)}` : '';
    return apiClient(`${BASE}/${query}`);
  },

  async getGrouped() {
    return apiClient(`${BASE}/grouped`);
  },

  async create(data) {
    return apiClient(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id) {
    return apiClient(`${BASE}/${id}`, {
      method: 'DELETE',
    });
  },

  async bulkDelete(ids) {
    return apiClient(`${BASE}/bulk-delete`, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
  },
};

export default procurementCatalogsAPI;
